import { api } from '@/service/http';

export const getContractCard = async id => {
    try {
        const { result, rows } = await api('counteragent./contract/card/get', { id });
        if (!result) {
            return {
                result: false,
                error: 'database result: false',
                uuid: 'c4d09d56-bfaa-4e5b-91f6-6bd75f533f85',
            };
        }
        return {
            result: true,
            data: rows,
        };
    } catch (error) {
        return {
            result: false,
            error: error.message,
            uuid: 'bca4d881-cee8-4eb5-8aee-10a01412b832',
        };
    }
};

export const getPodr= async id => {
    try {
        const { result, items, data } = await api('counteragent./contract/card/podr/get', {id: id});
        return result ? (items ? items : data) : [];
    } catch (error) {
        return {
            result: false,
            error: error.message,
            uuid: '',
        };
    }
};

export const getVid= async id => {
    try {
        const { result, items, data } = await api('counteragent./contract/card/vid/get', {id: id});
        return result ? (items ? items : data) : [];
    } catch (error) {
        return {
            result: false,
            error: error.message,
            uuid: '',
        };
    }
};

export const saveContractCard = async args => {
    try {
        const response = await api('counteragent./contract/card/save', args);
        return response;
    } catch (error) {
        return {
            result: false,
            error: error.message,
            uuid: '512c0d2c-32a5-4127-aaa3-90a7647a5d3d',
        };
    }
};
